<template>
  <div id="point-saved-step">
    <step-template>
      <div class="mb-6">Thank you. Your image has been added to the map successfully.</div>
      <div><csf-button type="primary" @click="viewPoint" class="mb-4 mr-4">View my pin</csf-button></div>
      <div><csf-button @click="browse" class="mb-4 mr-4">Browse all pins</csf-button></div>
      <div><csf-button @click="openFL" class="mb-4"><span class="pr-3">&larr;</span>Return to FutureLearn</csf-button></div>
    </step-template>
  </div>
</template>

<script>
import CsfButton from "../components/csf-button.vue";
import StepTemplate from "./step-template.vue";

export default {
  name: "point-saved-step",
  components: { CsfButton, StepTemplate },
  methods: {
    browse() {
      this.$router.push({ name: "browse" });
    },
    openFL() {
      window.location.href =
        "https://www.futurelearn.com/courses/fashion-and-sustainability";
    },
    viewPoint() {
      this.$router.push({
        name: "profile",
        params: { id: this.$store.state.anonUID }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// PointSavedStep.vue?11568fbc